import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { MainSidebar } from "common/components";
import { ContentUnavailableModal } from "application/common/components";
import { TrialActivatedModal } from "application/payment/components";
import { MrbProgressBarLoader } from "mrb/components/loader";
import { MrbConfirmDialog } from "mrb/components/modal";
import { mergeCss } from "mrb/common/utils";
import { defaultTemplate } from "common/hoc";
import { nakiRadioSystemTypes } from "common/constants";

function MainLayoutTemplate({ renderChildRoute, routeStore, t }) {
    const { rootStore } = routeStore;
    const { menuStore, userDeviceStore } = rootStore;
    // The portal takes the Kedayo Pink's colour while that device is selected, so the person can
    // see which device's catalogue they are looking at.
    const isKedayoPink =
        userDeviceStore &&
        userDeviceStore.selectedDevice &&
        userDeviceStore.selectedDevice.device &&
        userDeviceStore.selectedDevice.device.systemType &&
        userDeviceStore.selectedDevice.device.systemType.abrv === nakiRadioSystemTypes.mobile_handheld_pink;

    // Modals, dropdown menus and tooltips render through a portal on <body>, outside this shell,
    // so the flag is mirrored there as well or the theme would stop at the portal boundary.
    useEffect(() => {
        document.body.classList.toggle("is-kedayo-pink", !!isKedayoPink);
        return () => document.body.classList.remove("is-kedayo-pink");
    }, [isKedayoPink]);

    return (
        <div
            className={mergeCss(
                "l__admin",
                menuStore.isOpen ? "is-open" : null,
                isKedayoPink ? "is-kedayo-pink" : null
            )}
        >
            <MrbProgressBarLoader loaderStore={rootStore.mainLoaderStore} />
            <MainSidebar />
            <div className="l__admin--main">{renderChildRoute()}</div>
            <MrbConfirmDialog store={rootStore.confirmDialogStore} t={t} />
            <ContentUnavailableModal store={rootStore.userContentManagerStore} t={t} />
            <TrialActivatedModal modalParams={rootStore.applicationMainSectionStore.trialActivatedModal} />
        </div>
    );
}

MainLayoutTemplate.propTypes = {
    renderChildRoute: PropTypes.func.isRequired,
    routeStore: PropTypes.object.isRequired,
};

export default defaultTemplate(MainLayoutTemplate);
